import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

import { DeviceManagementComponentServiceAbstraction } from "@bitwarden/angular/auth/device-management/device-management-component.service.abstraction";
import { DeviceManagementItemGroupComponent } from "@bitwarden/angular/auth/device-management/device-management-item-group.component";
import { DeviceManagementComponent } from "@bitwarden/angular/auth/device-management/device-management.component";
import { IconModule } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

import { WebDeviceManagementComponentService } from "./web-device-management-component.service";
import { WebDeviceManagementTableComponent } from "./web-device-management-table.component";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-web-device-management",
  templateUrl: "./web-device-management.component.html",
  host: {
    class: "bv-security-devices-host",
  },
  providers: [
    {
      provide: DeviceManagementComponentServiceAbstraction,
      useClass: WebDeviceManagementComponentService,
    },
  ],
  imports: [
    CommonModule,
    DeviceManagementItemGroupComponent,
    IconModule,
    I18nPipe,
    WebDeviceManagementTableComponent,
  ],
})
export class WebDeviceManagementComponent extends DeviceManagementComponent {}
